<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M18.2916 5.8335L10.7991 10.606C10.5449 10.7537 10.2561 10.8314 9.96206 10.8314C9.66803 10.8314 9.37923 10.7537 9.12497 10.606L1.625 5.8335"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M16.6249 3.3335H3.29166C2.37119 3.3335 1.625 4.07969 1.625 5.00016V15.0001C1.625 15.9206 2.37119 16.6668 3.29166 16.6668H16.6249C17.5454 16.6668 18.2916 15.9206 18.2916 15.0001V5.00016C18.2916 4.07969 17.5454 3.3335 16.6249 3.3335Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconEnvelope',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
